import React from "react";
import { Box, Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const SplitButtonContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  overflow: "hidden",
  borderRadius: "8px",
  border: "1px solid #DBE8FF",
  backgroundColor: "#F5F8FF",
  height: "40px",
});

const MainButton = styled(Button)({
  borderRadius: 0,
  color: "#0057FF",
  textTransform: "none",
  padding: "0 16px",
  minWidth: "unset",
  height: "100%",

  "&:hover": {
    backgroundColor: "#DBE8FF",
  },
});

const Divider = styled(Box)({
  width: "1px",
  height: "100%",
  backgroundColor: "#DBE8FF",
});

const DropdownButton = styled(Button)({
  borderRadius: 0,
  minWidth: "44px",
  width: "44px",
  color: "#0057FF",
  padding: 0,
  height: "100%",

  "&:hover": {
    backgroundColor: "#DBE8FF",
  },
});

const CustomSplitButtonEdit = React.forwardRef(
  (
    {
      label,
      startIcon,
      onMainClick,
      onDropdownClick,
      disabled = false,
      dropdownDisabled = false,
      ...props
    },
    ref
  ) => {
    return (
      <SplitButtonContainer>
        <MainButton
          startIcon={startIcon}
          onClick={onMainClick}
          disabled={disabled}
          {...props}
        >
          {label}
        </MainButton>

        <DropdownButton
          ref={ref}
          onClick={onDropdownClick}
          disabled={disabled || dropdownDisabled}
        >
          <ArrowDropDownIcon />
        </DropdownButton>
      </SplitButtonContainer>
    );
  }
);

CustomSplitButtonEdit.displayName = "CustomSplitButtonEdit";

export default CustomSplitButtonEdit;